import { useState } from 'react';
import { FaqAnswer } from './FAQ';
import { DropdownCaret } from 'components/Dropdown';

import cx from 'classnames';
import styles from './FAQ.module.scss';

export type AnswerItemProps = {
  answer: FaqAnswer;
};

export const AnswerItem = ({ answer }: AnswerItemProps) => {
  const [open, isOpen] = useState(false);

  const toggleOpen = () => {
    isOpen((open) => !open);
  };

  return (
    <div className={styles.questionAnswer}>
      <div className={styles.answerHeader} onClick={toggleOpen}>
        <p>{answer.question}</p>
        <DropdownCaret isOpen={open} />
      </div>
      <div className={cx(styles.answerDescription, { [styles.answerOpened]: open })}>{answer.answer}</div>
    </div>
  );
};
